import { useState, useEffect, useContext } from 'react';
import {getFromServerToken} from './fetch'

const useListEvents = () => {
    const [isLoadingEvent, setIsLoadingEvent] = useState(false);
    const [eventData, setEventData] = useState(null);
    const [eventServerError, setServerError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingEvent(true);
            const {data, status} = await getFromServerToken('/events')
            if (status === 200) {
                if (data.events.length === 0) {
                    console.log("No Events found for user")
                    setEventData([])
                    setServerError("No Events found");    
                } else {
                    setEventData(data)
                }
            } else {
                console.log("Event FETCH Error")
                
                setEventData([])
                setServerError(data.detail);
            }
            setIsLoadingEvent(false);
        };

        fetchData();
    }, []);

    return { eventData, isLoadingEvent, eventServerError };
};

export default useListEvents